import { Injectable } from '@angular/core';
import { ApiService } from '@homeleite/arch';
import { RepositoryImpl } from '@homeleite/arch';
import { Producer, ProducerSummary } from './producer';

@Injectable({ providedIn: 'root' })
export class ProducersApiRepository extends RepositoryImpl<ProducerSummary, Producer> {
    constructor(api: ApiService) {
        super(api.root.path('/producers'), ProducerSummary, Producer);
    }
}
